import { UserInfo } from './auth.type';

export type ModuleType = string;

export type SessionState = {
  accessToken: string | null;
  module: ModuleType | null;
  userInfo: UserInfo | null;
};

export const LS_KEYS = {
  accessToken: 'access_token',
  module: 'module',
  userInfo: 'user',
  favoriteModules: 'favorite_module',
  language: 'lang',
  i18: {
    value: 'i18n_value',
    date: 'i18n_date',
  },
} as const;

export interface MODULE_LIST {
  id: string;
  icon: string;
  icon_active: string;
  label: string;
  route: string;
  disabled: boolean;
  type: 'module' | 'link';
  action?: () => void;
}

export type FAVERITE_MODULE = {
  lable: string;
};
